import { css, type Theme } from '@emotion/react';

import { TYPOGRAPHY_VARIANTS } from '../../../config/typography/constants';
import { removeButtonAppearance } from '../../../utils/style';

export const container = (theme: Theme) => css`
  display: flex;
  align-items: center;

  border-radius: 4px;
  border: 1px solid ${theme.colors.gray[200]};

  background-color: ${theme.colors.gray[0]};
`;

export const iconContainer = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${theme.colors.primary[15]};
  border-radius: 4px 0 0 4px;
  padding: 20px;
  border-right: 1px solid ${theme.colors.gray[100]};
`;

export const fileContainer = (theme: Theme) => css`
  color: ${theme.contrastColors.gray[0]};
  flex: 1;
  min-width: 0;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: ${
    parseInt(theme.typography[TYPOGRAPHY_VARIANTS.BODY_MEDIUM_REGULAR].lineHeight, 10) +
    parseInt(theme.typography[TYPOGRAPHY_VARIANTS.BODY_SMALL_BOLD].lineHeight, 10)
  }px;
`;

export const fileName = css`
  flex: 1;
  min-width: 0;
  margin-right: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const buttonsContainer = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (min-width: ${theme.breakpoints.medium}) {
    gap: 20px;
  }
`;

export const downloadLink = (theme: Theme) => css`
  ${removeButtonAppearance}
`;

export const spinner = (theme: Theme) => css`
  animation: ${theme.animations.rotate} 3s linear infinite;
`;
